import { Button, IconButton, Stack, SxProps, Typography } from "@mui/material";
import { useAtom, useAtomValue } from "jotai";
import { FC, useEffect } from "react";
import { currentVirtualViewerModeAtom } from "store/atoms/currentVirtualViewerModeAtom";
import { ShareTwoTone as ShareIcon } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { currentHotspotEventDataAtom } from "store/atoms/CurrentHotspotEventDataAtom";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useLoading } from "contexts/LoadingContext";

type UnityViewerOrbitModeToolbarProps = {
  shareHotspotHandler: () => void;
}

const UnityViewerVtourModeToolbar: FC<UnityViewerOrbitModeToolbarProps> = ({
  shareHotspotHandler,
}) => {

  const currentVtourViewerMode = useAtomValue(currentVirtualViewerModeAtom);
  const [currentHotspotEventData, setCurrentHotspotEventData] = useAtom(currentHotspotEventDataAtom);
  const isShareHotspotButtonLoading = currentHotspotEventData === "pending"
  const { fullscreen } = useLoading();

  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    // if we have data
    if (currentHotspotEventData && currentHotspotEventData !== "pending") {
      const urlParts = [
        window.location.origin,
        params.workspaceSlug,
        params.projectSlug,
        params.scanId,
        "viewer",
      ];
      const url = urlParts.join('/').concat(`?type=vtour&mode=uniscan&hotspotId=${currentHotspotEventData}`)
      navigator.clipboard.writeText(url);
      toast.success("Link to the hotspot copied to your clipboard")
      setCurrentHotspotEventData(undefined);
    }
  }, [currentHotspotEventData])

  const visible = currentVtourViewerMode.name === "VirtualTour";

  const hiddenStyles: SxProps = {
    top: -10,
    opacity: 0,
    pointerEvents: 'none',
    scale: .5,
  }

  const visibleStyles: SxProps = {
    top: fullscreen ? "4rem" : "1rem", // Move 2rem (32px) further down when in full screen
    opacity: 1,
    pointerEvents: 'all',
    scale: 1,
  }

  const animationStyles: SxProps = {
    transformOrigin: "top center",
    transition: "all .3s ease"
  }

  return (
    <Stack sx={{
      zIndex: 100,
      position: 'absolute',
      py: .5,
      px: 1,
      borderRadius: 2,
      backgroundColor: "background.paper",
      ...(visible ? visibleStyles : hiddenStyles),
      ...animationStyles,
    }}>
      <LoadingButton
        sx={{
          background: "#12121255",
          ":hover": {
            "background": "#12121222",
          },
          textTransform: "capitalize",
          color: "white",
          // padding: ".1rem",
        }}
        loading={isShareHotspotButtonLoading}
        onClick={shareHotspotHandler}
      >
        <Stack direction={"row"} gap={1} alignItems={"center"}>
          <ShareIcon sx={{ fontSize: ".75rem" }} />
          <Typography sx={{ fontSize: ".875rem" }}>Share Hotspot</Typography>
        </Stack>
      </LoadingButton>
    </Stack>
  )
}

export default UnityViewerVtourModeToolbar